// 入力項目の初期化
import { atom } from 'jotai';
import * as Const from '@/assets/Const';

export type ProvisionalRegistType = {
  email: string;
  recaptcha: string;
};

export const ProvisionalRegistAtoms = {
  emailAtom: atom<string>(''),
  recaptchaAtom: atom<string>('')
};

export const RegistAtoms = {
  nickNameAtom: atom<string>(''),
  familyNameAtom: atom<string>(''),
  firstNameAtom: atom<string>(''),
  familyNameKanaAtom: atom<string>(''),
  firstNameKanaAtom: atom<string>(''),
  emailAtom: atom<string>(''),
  passwordAtom: atom<string>(''),
  birthdayAtom: atom<string>(''),
  genderAtom: atom<number | undefined>(undefined),
  dinerExperienceAtom: atom<number | undefined>(undefined),
  dinerExpTypeAtom: atom<Const.selectItem[]>([]),
  opnSchedTimeAtom: atom<Const.selectItem[]>([]),
  tempIdAtom: atom<number>(0),
  checksumAtom: atom<string>(''),
  mailCheckAtom: atom<Const.selectItem[]>(Const.INITIAL_MAIL_CHECK),
  openingFundsAtom: atom<Const.selectItem[]>([]),
  openingStatusAtom: atom<Const.selectItem[]>([]),
  ownFundsAtom: atom<Const.selectItem[]>([]),
  openingIndustryTypeAtom: atom<Const.selectItem[]>([]),
  existingStoreCountAtom: atom<Const.selectItem[]>([]),
  openingPrefectureAtom: atom<Const.selectItem[]>([]),
  hashValueAtom: atom<string | null>(null),
  phoneNumberAtom: atom<string>(''),
  isWillOpenAtom: atom<number | undefined>(undefined),
  businessTypeAtom: atom<Const.selectItem[]>([]),
  companyNameAtom: atom<string>(''),
  storeCountAtom: atom<string>(''),
  usedSystemAtom: atom<Const.selectItem[]>([]),
  concernAtom: atom<Const.selectItem[]>([]),
  postSignupRedirectPathAtom: atom<string>(''),
  futureVisionAtom: atom<Const.selectItem[]>([]),
  memberStoresAtom: atom<MemberStoreType[]>([
    {
      storeName: '',
      address: '',
      industryTypeAndOpeningHours: ''
    }
  ]),
  locationsAtom: atom<string[]>([])
};

export type MemberStoreType = {
  storeName: string;
  address: string;
  industryTypeAndOpeningHours: string;
};

export const consentRegitAtoms = {
  category: atom<Const.selectItem[]>([Const.defaultObjValue]),
  ts: atom<Const.selectItem[]>([Const.defaultObjValue]),
  pp: atom<Const.selectItem[]>([Const.defaultObjValue])
};
